import React from 'react';
import logo from '../assets/easylease.svg';

const Logo = (prop) => {
    return (
        <img
            style={{ maxHeight: '60px', float: 'left', objectFit: 'contain', cursor: 'pointer' }}
            src={logo}
            alt="Yoma Fleet"
            onClick={() => prop.redirectHome()}
        />
    );
};

export default Logo;